import React from 'react'
import './textDesk.css'

export default function TextDesk ({ danger, message, ...props }) {
  return <span className={danger ? 'bpp-textDesk-danger' : 'bpp-textDesk'} {...props} > {message} </span>
}
